import { render } from "./BannerGPT.vue?vue&type=template&id=b8d620b8&scoped=true"
import script from "./BannerGPT.vue?vue&type=script&lang=js"
export * from "./BannerGPT.vue?vue&type=script&lang=js"

import "./BannerGPT.vue?vue&type=style&index=0&id=b8d620b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8d620b8"]])

export default __exports__